"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledCol = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _Resizer = require("./Resizer");
var _ykbUtils = require("ykb-utils");
var _excluded = ["hidden", "hiddenDown", "hiddenUp", "visible", "className", "children", "observeElement"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledCol = exports.StyledCol = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-c48kic-0"
})(["position:relative;min-height:1px;", " ", ""], function (props) {
  return !props.noPadding && (0, _ykbStyledComponents.css)(["padding-left:", ";padding-right:", ";"], function (props) {
    return props.theme.gutter;
  }, function (props) {
    return props.theme.gutter;
  });
}, function (props) {
  return !props.container && (0, _ykbStyledComponents.css)(["", " ", " ", " ", " @media ", "{", " ", " ", " ", "}@media ", "{", " ", " ", " ", "}@media ", "{", " ", " ", " ", "}"], function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.xs) && (0, _ykbStyledComponents.css)(["float:left;width:", "%;"], function (props) {
      return (100 * (props.xs / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.xsPull) && (0, _ykbStyledComponents.css)(["right:", "%;"], function (props) {
      return props.xsPull === 0 ? 'auto' : (100 * (props.xsPull / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.xsPush) && (0, _ykbStyledComponents.css)(["left:", "%;"], function (props) {
      return props.xsPush === 0 ? 'auto' : (100 * (props.xsPush / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.xsOffset) && (0, _ykbStyledComponents.css)(["margin-left:", "%;"], function (props) {
      return props.xsOffset === 0 ? 'auto' : (100 * (props.xsOffset / 24)).toFixed(6);
    });
  }, function (props) {
    return props.theme.responsive.small;
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.sm) && (0, _ykbStyledComponents.css)(["float:left;width:", "%;"], function (props) {
      return (100 * (props.sm / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.smPull) && (0, _ykbStyledComponents.css)(["right:", "%;"], function (props) {
      return props.smPull === 0 ? 'auto' : (100 * (props.smPull / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.smPush) && (0, _ykbStyledComponents.css)(["left:", "%;"], function (props) {
      return props.smPush === 0 ? 'auto' : (100 * (props.smPush / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.smOffset) && (0, _ykbStyledComponents.css)(["margin-left:", "%;"], function (props) {
      return props.smOffset === 0 ? 'auto' : (100 * (props.smOffset / 24)).toFixed(6);
    });
  }, function (props) {
    return props.theme.responsive.medium;
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.md) && (0, _ykbStyledComponents.css)(["float:left;width:", "%;"], function (props) {
      return (100 * (props.md / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.mdPull) && (0, _ykbStyledComponents.css)(["right:", "%;"], function (props) {
      return props.mdPull === 0 ? 'auto' : (100 * (props.mdPull / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.mdPush) && (0, _ykbStyledComponents.css)(["left:", "%;"], function (props) {
      return props.mdPush === 0 ? 'auto' : (100 * (props.mdPush / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.mdOffset) && (0, _ykbStyledComponents.css)(["margin-left:", "%;"], function (props) {
      return props.mdOffset === 0 ? 'auto' : (100 * (props.mdOffset / 24)).toFixed(6);
    });
  }, function (props) {
    return props.theme.responsive.large;
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.lg) && (0, _ykbStyledComponents.css)(["float:left;width:", "%;"], function (props) {
      return (100 * (props.lg / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.lgPull) && (0, _ykbStyledComponents.css)(["right:", "%;"], function (props) {
      return props.lgPull === 0 ? 'auto' : (100 * (props.lgPull / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.lgPush) && (0, _ykbStyledComponents.css)(["left:", "%;"], function (props) {
      return props.lgPush === 0 ? 'auto' : (100 * (props.lgPush / 24)).toFixed(6);
    });
  }, function (props) {
    return !(0, _ykbUtils.isNullOrUndefined)(props.lgOffset) && (0, _ykbStyledComponents.css)(["margin-left:", "%;"], function (props) {
      return props.lgOffset === 0 ? 'auto' : (100 * (props.lgOffset / 24)).toFixed(6);
    });
  });
});
var Col = /*#__PURE__*/function (_React$Component) {
  function Col(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Col);
    _this = _callSuper(this, Col, [props]);
    var observeElement = _this.props.observeElement;
    if (observeElement === 'container') {
      _this.container = (0, _Resizer.handleContainer)();
    }
    return _this;
  }
  (0, _inherits2.default)(Col, _React$Component);
  return (0, _createClass2.default)(Col, [{
    key: "updateAndParse",
    value: function updateAndParse(props) {
      for (var _i = 0, _Object$keys = Object.keys(props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (Col.NUMBERIC_CHECK_LIST[key]) {
          var value = props[key];
          if (typeof value === 'number') {
            continue;
          }
          value = parseInt(value, 10);
          if (isNaN(value)) {
            delete props[key];
          } else {
            props[key] = value;
          }
          if (value > 24 || value < 0) {
            console.warn("ykb-ui Grid: ".concat(key, " should be between 0 and 24"));
            delete props[key];
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;
      var _this$props = this.props,
        hidden = _this$props.hidden,
        hiddenDown = _this$props.hiddenDown,
        hiddenUp = _this$props.hiddenUp,
        visible = _this$props.visible,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? '' : _this$props$className,
        children = _this$props.children,
        observeElement = _this$props.observeElement,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var container = observeElement === 'container' && !!this.container;
      var cls = (0, _classnames.default)(className, (_classNames = {}, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_classNames, "hidden-".concat(hidden), typeof hidden === 'string' && hidden && !container), "hidden", typeof hidden !== 'string' && hidden && !container), "hidden-".concat(hidden, "-container"), typeof hidden === 'string' && hidden && container), "hidden-container", typeof hidden !== 'string' && hidden && container), "hidden-".concat(hiddenDown, "-down"), hiddenDown && !container), "hidden-".concat(hiddenUp, "-up"), hiddenUp && !container), "hidden-".concat(hiddenDown, "-container-down"), hiddenDown && container), "hidden-".concat(hiddenUp, "-container-up"), hiddenUp && container), "visible-".concat(visible), typeof visible === 'string' && visible && !container), "visible", typeof visible !== 'string' && visible && !container), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_classNames, "visible-".concat(visible, "-container"), typeof visible === 'string' && visible && container), "visible-container", typeof visible !== 'string' && visible && container), "col-xl-".concat(this.props.xl, "-container"), this.props.xl && container), "col-lg-".concat(this.props.lg, "-container"), this.props.lg && container), "col-md-".concat(this.props.md, "-container"), this.props.md && container), "col-sm-".concat(this.props.sm, "-container"), this.props.sm && container), "col-xs-".concat(this.props.xs, "-container"), this.props.xs && container), "col-xs-".concat(rest.span, "-container"), !this.props.xs && rest.span > 0 && container), "col-pull-xl-".concat(this.props.xlPull, "-container"), this.props.xlPull && container), "col-pull-lg-".concat(this.props.lgPull, "-container"), this.props.lgPull && container), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_classNames, "col-pull-md-".concat(this.props.mdPull, "-container"), this.props.mdPull && container), "col-pull-sm-".concat(this.props.smPull, "-container"), this.props.smPull && container), "col-pull-xs-".concat(this.props.xsPull, "-container"), this.props.xsPull && container), "col-push-xl-".concat(this.props.xlPush, "-container"), this.props.xlPush && container), "col-push-lg-".concat(this.props.lgPush, "-container"), this.props.lgPush && container), "col-push-md-".concat(this.props.mdPush, "-container"), this.props.mdPush && container), "col-push-sm-".concat(this.props.smPush, "-container"), this.props.smPush && container), "col-push-xs-".concat(this.props.xsPush, "-container"), this.props.xsPush && container), "col-offset-xl-".concat(this.props.xlOffset, "-container"), this.props.xlOffset && container), "col-offset-lg-".concat(this.props.lgOffset, "-container"), this.props.lgOffset && container), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_classNames, "col-offset-md-".concat(this.props.mdOffset, "-container"), this.props.mdOffset && container), "col-offset-sm-".concat(this.props.smOffset, "-container"), this.props.smOffset && container), "col-offset-xs-".concat(this.props.xsOffset, "-container"), this.props.xsOffset && container)));

      // deletes and converts to int str values
      this.updateAndParse(_objectSpread(_objectSpread({}, rest), {}, {
        observeElement: observeElement
      }));

      // override xs for span
      // TODO: CHECK this usage
      if (rest.span > 0) {
        rest.xs = rest.span;
      }
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(StyledCol, (0, _extends2.default)({
          className: cls
        }, rest, {
          theme: theme,
          container: container
        }), children);
      });
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(Col, "NUMBERIC_CHECK_LIST", {
  xs: true,
  sm: true,
  md: true,
  lg: true,
  span: true,
  xsOffset: true,
  smOffset: true,
  mdOffset: true,
  lgOffset: true,
  xsPull: true,
  smPull: true,
  mdPull: true,
  lgPull: true,
  xsPush: true,
  smPush: true,
  mdPush: true,
  lgPush: true
});
Col.defaultProps = {
  observeElement: 'window'
};
Col.propTypes = {
  xs: _propTypes.default.number,
  sm: _propTypes.default.number,
  md: _propTypes.default.number,
  lg: _propTypes.default.number,
  /**
   * xl should be used in container.
   */
  xl: _propTypes.default.number,
  span: _propTypes.default.number,
  xsPull: _propTypes.default.number,
  smPull: _propTypes.default.number,
  mdPull: _propTypes.default.number,
  lgPull: _propTypes.default.number,
  xlPull: _propTypes.default.number,
  xsPush: _propTypes.default.number,
  smPush: _propTypes.default.number,
  mdPush: _propTypes.default.number,
  lgPush: _propTypes.default.number,
  xlPush: _propTypes.default.number,
  xsOffset: _propTypes.default.number,
  smOffset: _propTypes.default.number,
  mdOffset: _propTypes.default.number,
  lgOffset: _propTypes.default.number,
  xlOffset: _propTypes.default.number,
  hidden: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', true, false]),
  visible: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', true, false]),
  hiddenDown: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  hiddenUp: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * You may experience browser/browser-version related issues in container.
   */
  observeElement: _propTypes.default.oneOf(['window', 'container'])
};
var _default = exports.default = Col;